import { useState, useEffect } from 'react';
import MyTransactionsComponent from './myTransactionsComponent';
import MyMaterialComponent from './myMaterialComponent';
import { bake } from './common';

export default function MyMaterialHomePage(props) {
  // display SSD by default
  const [materialType, setMaterialType] = useState('SSD');
  //tabs for user to select SSD or Component
  const materialTypes = ['SSD', 'Component'];

  useEffect(() => {
    // Check if there's a saved material type in local storage
    let material = bake({ key: 'materialTypeTab' }) ?? 'SSD';
    // If the saved material type is not in the list, default to 'SSD'
    setMaterialType(material);
  }, []);

  const handleMaterialTypeChange = (material) => {
    setMaterialType(material);
    bake({ key: 'materialTypeTab', value: material });
  };

  return (
    <>
      <div className="mt-2 justify-content-between">
        <div className="mb-2 d-flex nav-tabs-container">
          {materialTypes.map((material, i) => (
            <div
              key={i}
              className={
                materialType === material ? 'nav-tab-active' : 'nav-tab'
              }
              onClick={() => {
                handleMaterialTypeChange(material);
              }}
            >
              {material}
            </div>
          ))}
        </div>
      </div>
      <div className="myHomePage-container">
        <MyTransactionsComponent
          matType={materialType}
          level={props.level}
          myHomePage={true}
        />
        <MyMaterialComponent
          matType={materialType}
          level={props.level}
          myHomePage={true}
        />
      </div>
    </>
  );
}
